import React, { useEffect, useState } from 'react';
import Layout from 'layout/layout';
import { Form, Spinner, Table } from 'react-bootstrap';
import { HiOutlineEye, HiOutlineTrash } from 'react-icons/hi';
import { TbEdit } from 'react-icons/tb';
import { BiUserPlus } from 'react-icons/bi';
import ModalComponent from 'components/modal-component';
import { AiOutlineClose } from 'react-icons/ai';
import { GoChevronRight, GoCircleSlash, GoFilter, GoPlus } from 'react-icons/go';
import OffCanvasModal from 'components/offCanvas-modal';
import Suspend from '../../assets/images/suspend-user.gif';
import info from '../../assets/images/info.gif';
import UserModalTabs from './UserModalTabs';
import { useDeleteRoleMutation, useDeleteUserMutation, useGetPermissionsByIdQuery, useGetPermissionsQuery, useGetRolesQuery, useGetSuspendedUsersQuery, useGetUsersWithFilterQuery, useReactivateUsersMutation, useSuspendUsersMutation } from 'api/userManagementApi';
import { showToastError, showToastSuccess } from 'components/toastify/ToastNotifications';
import { useDispatch } from 'react-redux';
import { PermissionModel, RoleItemModel, RoleModel } from 'model/roles-permission-model';
import { FilterUserModel, ItemModel, UserResponseModel } from 'model/users-model';
import { FormattedDate } from 'components/formatted-date';
import RoleModalTabs from './RoleModalTabs';
import { retrieveUserData } from 'redux/authSlice';
import { PiLockKey } from 'react-icons/pi';
import { HiUsers } from 'react-icons/hi2';
import Pagination from 'rc-pagination';
import '../../styles/request.css';

type Props = {}

const UserManagement: React.FC = (props: Props) => {

const userData = retrieveUserData();
const userRoleId = userData?.roleId;

const { data: userPermissionsData,isFetching: fetchingPermission, refetch: refetchUserPermission } = useGetPermissionsByIdQuery(userRoleId!, {
  skip: !userRoleId,
});

  // const { data: userPermissionsData, isFetching: fetchingPermission, refetch: refetchUserPermission } = useGetPermissionsByIdQuery(userRoleId, { skip: userRoleId ? false : true });
   
useEffect(() => {
  if (!userRoleId) return; 

  refetchUserPermission();
}, [userRoleId]);
  
  const viewUserPermission = userPermissionsData?.data && userPermissionsData?.data?.permissions?.includes("View Users");
  const rolePermission = userPermissionsData?.data && userPermissionsData?.data?.permissions?.includes("View Roles");
  const manageUserPermission = userPermissionsData?.data && userPermissionsData?.data?.permissions?.includes("Modify Users");

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loadingButtons, setLoadingButtons] = useState<{ [key: string]: boolean }>({});
  const [showModal, setShowModal] = useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState('add-user');
  const [activeUser, setActiveUser] = useState('users');
  const [modalUserData, setModalUserData] = useState<UserResponseModel>();
  const [modalRoleData, setModalRoleData] = useState<RoleModel>()
  const [filterByDate, setFilterByDate] = useState('');
  const [filterByRole, setFilterByRole] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(true);
  const [selectedUser, setSelectedUser] = useState<string>('');
  const [queryUser, setQueryUser] = useState<FilterUserModel>({
    OrderBy: '',
    RoleName: '',
    Page: 1,
    PageSize: 10
  })

  const onPageChange = (page: number) => {
    setQueryUser((prev) => ({ ...prev, Page: page }));
    // You can perform actions like fetching data for the new page here
  };

  const [querySuspendedUser, setQuerySuspendedUser] = useState<FilterUserModel>({
    OrderBy: '',
    RoleName: '',
    Page: 1,
    PageSize: 10
  })

  const onPageChangeSuspendedUser = (page: number) => {
    setQuerySuspendedUser((prev) => ({ ...prev, Page: page }));
    // You can perform actions like fetching data for the new page here
  };

  const [queryRole, setQueryRole] = useState<FilterUserModel>({
    OrderBy: '',
    RoleName: '',
    Page: 1,
    PageSize: 10
  })

  const onPageChangeRole = (page: number) => {
    setQueryRole((prev) => ({ ...prev, Page: page }));
    // You can perform actions like fetching data for the new page here
  };

  const { data: rolesData, error: rolesError, isFetching: rolesIsFetching, refetch: refetchRoles } = useGetRolesQuery(queryRole);
  const { data: permissionsData, error: permissionsError, isFetching: permissionsIsFetching, refetch: refetchPermissions } = useGetPermissionsQuery();
  const { data: usersData, error: usersError, isFetching: usersIsFetching, refetch: refetchUser } = useGetUsersWithFilterQuery(queryUser);
  const { data: usersSuspendedData, error: usersSuspendedError, isFetching: usersSuspendedIsFetching, refetch: refetchSuspendedUser } = useGetSuspendedUsersQuery(querySuspendedUser);

  const [suspendUser, suspendUserResult] = useSuspendUsersMutation();
  const [reactivateUsers, reactivateUsersResult] = useReactivateUsersMutation();

  const [roles, setRoles] = useState<RoleItemModel>();
  const [permissions, setPermissions] = useState<PermissionModel[]>([]);
  const [adminUsers, setAdminUsers] = useState<ItemModel>();
  const [suspendedUser, setSuspendedUsers] = useState<ItemModel>();

  useEffect(() => {
    if (rolesIsFetching) {
      setLoading(true);
    }
    else {
      setLoading(false);
      if (rolesError) {
        showToastError('Unable to fetch dat from the server')
      }
      else {
        setRoles(rolesData?.data as RoleItemModel)
      }
    }
  }, [rolesIsFetching, rolesError, showModal]);

  useEffect(() => {
    if (permissionsIsFetching) {
      setLoading(true);
    }
    else {
      setLoading(false);
      if (permissionsError) {
        showToastError('Unable to fetch dat from the server')
      }
      else {
        setPermissions(permissionsData?.data as PermissionModel[])
      }
    }
  }, [permissionsIsFetching, permissionsError]);


  useEffect(() => {
    if (usersIsFetching) {
      setLoading(true);
    }
    else {
      setLoading(false);
      if (usersError) {
        showToastError('Unable to fetch dat from the server')
      }
      else {
        setAdminUsers(usersData?.data as ItemModel)
      }
    }
  }, [usersIsFetching, usersError, showModal]);

  useEffect(() => {
    if (usersSuspendedIsFetching) {
      setLoading(true);
    }
    else {
      setLoading(false);
      if (usersSuspendedError) {
        showToastError('Unable to fetch dat from the server')
      }
      else {
        setSuspendedUsers(usersSuspendedData?.data as ItemModel)
      }
    }
  }, [usersSuspendedIsFetching, usersSuspendedError, showModal]);

  useEffect(() => {
    refetchUser(); // Ensure data refetches when page changes
  }, [queryUser.Page]);

  useEffect(() => {
    refetchRoles(); // Ensure data refetches when page changes
  }, [queryRole.Page]);

  useEffect(() => {
    refetchSuspendedUser(); // Ensure data refetches when page changes
  }, [querySuspendedUser.Page]);

  const handleHideOffCanvas = () => {
    setShowOffCanvas(false);
  }

  const handleHideModal = () => {
    setShowModal(false);
    refetchUser();
    setModalUserData(undefined);
  };

  const handleRefetchRoles = () => {
    refetchUser();
    refetchRoles();
    refetchPermissions();
  };
  const handleRefetchUsers = () => { refetchUser(); refetchRoles(); refetchPermissions() };
  const [deleteRole] = useDeleteRoleMutation();
  const [deleteUser] = useDeleteUserMutation();

  const handleDeleteRole = async (id: string) => {
    try {
      setLoadingButtons((prevLoadingButtons) => ({
        ...prevLoadingButtons,
        [id]: true,
      }));
      const response = await deleteRole(id).unwrap();
      if (response) {
        showToastSuccess(response?.ResponseMessage);
        refetchRoles();
      }
    }
    catch (error: any) {
      showToastError(error?.data.ResponseMessage)
    }
    finally {
      setLoadingButtons((prevLoadingButtons) => ({
        ...prevLoadingButtons,
        [id]: false,
      }));
    }
  };

  const handleDeleteUser = async () => {
    try {
      setLoading(true);
      const response = await deleteUser(selectedUser).unwrap();
      if (response) {
        showToastSuccess(response?.ResponseMessage);
        refetchUser();
        refetchSuspendedUser();
        setShowModal(false);
      }
    }
    catch (error: any) {
      showToastError(error?.data.ResponseMessage)
    }
    finally {
      setLoading(false);
    }
  };

  const handleFilterUser = () => {
    setQueryUser({ ...queryUser, RoleName: filterByRole, OrderBy: filterByDate })
    //refetchUser();
    handleHideOffCanvas();
  }

  const handleClearFilter = () => {
    setFilterByDate('');
    setFilterByRole('')
    setQueryUser({ ...queryUser, RoleName: '', OrderBy: '' });
  }

  // const filteredRole = Array.from(new Set(adminUsers?.items?.map(obj => obj.role)))?.map(role => {
  //   return adminUsers?.items?.find(obj => obj.role === role);
  // });

  const [selectedUserIds, setSelectedUserIds] = useState<string[]>([]);

  const handleCheckboxChange = (userId: string | undefined) => {
    if (userId) {
      setSelectedUserIds((prevSelectedUserIds) => {
        if (prevSelectedUserIds.includes(userId)) {
          // If user ID is already in the array, remove it
          return prevSelectedUserIds.filter((id) => id !== userId);
        } else {
          // If user ID is not in the array, add it
          return [...prevSelectedUserIds, userId];
        }
      });
    }
  };

  const handleCheckboxAllUser = () => {
    if (adminUsers && selectedUserIds?.length < adminUsers?.items?.length) {
      setSelectedUserIds(adminUsers && adminUsers?.items?.map((user) => user?.userId));
    }
    else {
      setSelectedUserIds([]);
    }
  }

  const handleSuspendUser = async () => {
    try {
      setLoading(true);
      const model = {
        userIds: selectedUserIds
      }
      const response = await suspendUser(model).unwrap();
      if (response) {
        showToastSuccess(response?.ResponseMessage);
        handleHideModal()
        refetchUser();
        refetchSuspendedUser();
        setSelectedUserIds(['']);
      }
    }
    catch (error: any) {
      showToastError(error?.data.ResponseMessage)
    }
    finally {
      setLoading(false);
    }
  }

  const handleReactivateUser = async () => {
    try {
      setLoading(true);
      const model = {
        userIds: selectedUserIds
      }
      const response = await reactivateUsers(model).unwrap();
      if (response) {
        showToastSuccess(response?.ResponseMessage);
        handleHideModal()
        refetchUser();
        refetchSuspendedUser();
        setSelectedUserIds(['']);
      }
    }
    catch (error: any) {
      showToastError(error?.data.ResponseMessage)
    }
    finally {
      setLoading(false);
    }
  }




  return (
    <Layout>
      <section className='mt-0 mb-5'>
        <div className='sticky-top bg-light pt-3 pb-2 mb-2' style={{ top: '0', zIndex: 10, margin: '0 -50px', padding: '0 50px' }}>
          <h5 className='fw-bold'>User Management</h5>
          <div className='text-secondary font-size-normal'><span>User Management</span> <GoChevronRight className='my-2' />  <span>{activeUser === 'role' ? 'Roles' : activeUser === 'users' ? 'Users' : 'Suspended Users'}</span></div>

          <div className='d-flex justify-content-between mt-4 mb-2'>
            <div>
              {viewUserPermission && <> <button onClick={() => setActiveUser("users")} className={activeUser === "users" ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3"}>Users</button>
                {suspendedUser?.items?.length !== 0 && <button onClick={() => setActiveUser('suspended')} className={activeUser === 'suspended' ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3"}>Suspended Users</button>}</>}
              {rolePermission && <button onClick={() => setActiveUser('role')} className={activeUser === 'role' ? "btn-primary-outline font-size-sm first-font-medium px-3 me-3" : "btn-secondary-outline font-size-sm first-font-medium px-3 me-3"}>Roles</button>}
            </div>

            <div className='d-flex gap-2'>
              {activeUser === 'suspended' && <button onClick={() => { setShowModal(true); setActiveModalTab('reactivate-user') }} className='btn-primary py-2 px-3'> <BiUserPlus size={20} /> Reactivate user</button>}
              {activeUser === 'users' && <>
                {selectedUserIds?.length > 0 && <button onClick={() => { setShowModal(true); setActiveModalTab('suspend-user') }} className='btn-yellow px-3 ms-2'> <GoCircleSlash size={20} /> Suspend</button>}
                {manageUserPermission && <button onClick={() => { setShowModal(true); setActiveModalTab('add-user') }} className='btn-primary py-2 px-3 ms-2'> <GoPlus size={20} /> Add new user</button>}
              </>}
              {activeUser === 'role' && <button hidden={!manageUserPermission} onClick={() => { setShowModal(true); setActiveModalTab('add-role') }} className='btn-primary py-2 px-5'> <GoPlus size={20} /> Add new Role</button>}
              {(filterByDate || filterByRole) && <button type='button' onClick={() => handleClearFilter()} className='btn btn-secondary ms-2'>Clear Filter</button>}
              <button onClick={() => setShowOffCanvas(true)} className='btn-secondary-outline ms-2 px-3'> <GoFilter size={20} className='me-2' /> Filter</button>
            </div>
          </div>
        </div>
        <OffCanvasModal showOffCanvas={showOffCanvas} hideOffCanvas={handleHideOffCanvas}>
          <div className='px-4'>
            <h3 className='fw-bold mt-n4 mb-4'>Filter</h3>
            <div>
              <p className="dark-text">VIEW BY</p>
              <p><Form.Check label='Recently Added' name='RecentlyAdded' checked={filterByDate === 'RecentlyAdded'} onClick={() => setFilterByDate('RecentlyAdded')} id='date' className="dark-text" /></p>
              <p><Form.Check label='Oldest First' name='Oldest' checked={filterByDate === 'Oldest'} onChange={() => setFilterByDate('Oldest')} id='date' className="dark-text" /></p>
            </div>
            <hr className='my-5' />
            <div className='mb-5'>
              <p className="dark-text">FILTER BY ROLE</p>
              {roles?.items?.map((roles, key) => <p key={key}><Form.Check label={roles?.name} checked={filterByRole === roles?.name} onChange={() => setFilterByRole(roles?.name as any)} name='role' id='role' className="dark-text" /></p>)}
            </div>
            <div className='pt-5'><button type='button' onClick={() => handleFilterUser()} className='btn-primary w-100 py-2'>Apply filter</button></div>
          </div>
        </OffCanvasModal>

        {activeUser === 'role' && rolePermission && <>
          {loading ? <div className='text-center p-5'><Spinner /> <p>Loading... </p></div> : <>
            <div className='request-table' style={{ maxHeight: 'none', overflowY: 'visible' }}>
              <Table className='table sticky-thead'>
                <thead>
                  <tr>
                    <th>
                      <label className='fw-normal'>SN</label>
                    </th>
                    <th>
                      <label className='fw-normal'>Role</label>
                    </th>
                    <th>
                      <label className='fw-normal'>Date Created</label>
                    </th>
                    <th>
                      <label className='fw-normal'>No users</label>
                    </th>
                    <th className='px-3 text-end'>
                      <label className='fw-normal'>Action</label>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {roles?.items?.map((role, key) => <tr key={key} className='align-middle'>
                    <td>{((queryRole?.Page - 1) * queryRole?.PageSize) + key + 1}</td>
                    <td><span className='text-secondary'>{role.name}</span></td>
                    <td><span className='text-secondary'>{FormattedDate(role.dateCreatedInEpochMilliseconds)}</span></td>
                    <td><span className='text-secondary'>{role.numberOfUsers}</span></td>
                    <td>
                      <div className='d-flex gap-2 justify-content-end'>
                        {/* <button onClick={() => { setShowModal(true); setActiveModalTab('view-user') }} className='btn py-2 px-2 rounded-3'><HiOutlineEye size={20} className='primary-text' /> View Users</button> */}
                        <button onClick={() => { setShowModal(true); setModalRoleData(role); setActiveModalTab('viewUsers') }} className='btn py-2 px-5 rounded-3'><HiUsers size={20} className='primary-text' /> View Users</button>
                        <button onClick={() => { setShowModal(true); setModalRoleData(role); setActiveModalTab('edit-role') }} className='btn py-2 px-5 rounded-3'><TbEdit size={20} className='primary-text' /> Edit Role</button>
                        <button disabled={loadingButtons[role.id]} onClick={() => handleDeleteRole(role.id)} className='btn py-2 px-2 text-danger rounded-3'>{loadingButtons[role.id] ? (<Spinner size='sm' />) : (<HiOutlineTrash size={20} className='danger-primary' />)} Delete Role</button>
                      </div>
                    </td>
                  </tr>)}
                </tbody>
              </Table>

              <div className='text-end py-3'>
                <Pagination
                  current={roles?.pageNumber ?? queryRole.Page}
                  total={roles?.totalSize}
                  pageSize={roles?.pageSize}
                  onChange={onPageChangeRole}
                />
              </div>
            </div>
          </>}
        </>}

        {activeUser === 'users' && viewUserPermission && <>
          {loading ? <div className='text-center p-5'><Spinner /> <p>Loading... </p></div> : <>
            <div className='request-table' style={{ maxHeight: 'none', overflowY: 'visible' }}>
              <Table className='table sticky-thead'>
                <thead>
                  <tr>
                    <th><Form.Check onChange={() => handleCheckboxAllUser()} /></th>
                    <th>
                      <label className='fw-normal'>SN</label>
                    </th>
                    <th>
                      <label className='fw-normal'>Name</label>
                    </th>
                    <th>
                      <label className='fw-normal'>Email</label>
                    </th>
                    <th>
                      <label className='fw-normal'>Role</label>
                    </th>
                    <th>
                      <label className='fw-normal'>Date Created</label>
                    </th>
                    {manageUserPermission && <th className='px-3 text-end'>
                      <label className='fw-normal'>Actions</label>
                    </th>}
                  </tr>
                </thead>
                <tbody>
                  {adminUsers?.items?.map((item, key) => <tr key={key} className='align-middle'>
                    <td><Form.Check checked={selectedUserIds.includes(item?.userId)} onChange={() => handleCheckboxChange(item?.userId)} /></td>
                    <td>{((queryUser?.Page - 1) * queryUser?.PageSize) + key + 1}</td>
                    <td><span className='text-secondary'>{item?.lastName} {item?.firstName}</span></td>
                    <td><span className='text-secondary'>{item?.email}</span></td>
                    <td><span className='text-secondary'>{item?.role}</span></td>
                    <td><span className='text-secondary'>{FormattedDate(item?.dateCreatedInEpochMilliseconds)}</span></td>
                    {manageUserPermission && <td>
                      <div className='d-flex gap-3 justify-content-end'>
                        <button onClick={() => { setShowModal(true); setModalUserData(item); setActiveModalTab('view-user') }} className='btn py-2 px-2 rounded-3'><HiOutlineEye size={20} className='primary-text' /> View Users</button>
                        <button onClick={() => { setShowModal(true); setActiveModalTab('delete-user'); setSelectedUser(item?.userId) }} className='btn py-2 px-2 text-danger rounded-3'><HiOutlineTrash size={20} className='danger-primary' /> Delete User</button>
                      </div>
                    </td>}
                  </tr>)}
                </tbody>
              </Table>

              <div className='text-end py-3'>
                <Pagination
                  current={adminUsers?.pageNumber ?? queryUser.Page}
                  total={adminUsers?.totalSize}
                  pageSize={adminUsers?.pageSize}
                  onChange={onPageChange}
                />
              </div>
            </div>
          </>}
        </>}

        {activeUser === 'suspended' && viewUserPermission && <>
          <div className='request-table' style={{ maxHeight: 'none', overflowY: 'visible' }}>
            <Table className='table sticky-thead'>
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <label className='fw-normal'>SN</label>
                  </th>
                  <th>
                    <label className='fw-normal'>Name</label>
                  </th>
                  <th>
                    <label className='fw-normal'>Email</label>
                  </th>
                  <th>
                    <label className='fw-normal'>Role</label>
                  </th>
                  <th>
                    <label className='fw-normal'>Date Created</label>
                  </th>
                  <th className='px-3 text-end'>
                    <label className='fw-normal'>Actions</label>
                  </th>
                </tr>
              </thead>
              <tbody>
                {suspendedUser?.items?.map((item, key) => <tr key={key} className='align-middle'>
                  <td><Form.Check onChange={() => handleCheckboxChange(item?.userId)} /></td>
                  <td>{((querySuspendedUser?.Page - 1) * querySuspendedUser?.PageSize) + key + 1}</td>
                  <td><span className='text-secondary'>{item?.lastName} {item?.firstName}</span></td>
                  <td><span className='text-secondary'>{item?.email}</span></td>
                  <td><span className='text-secondary'>{item?.role}</span></td>
                  <td><span className='text-secondary'>{FormattedDate(item?.dateCreatedInEpochMilliseconds)} </span></td>
                  <td>
                    <div className='d-flex gap-3 justify-content-end'>
                      {/* <button onClick={() => { setShowModal(true); setActiveModalTab('view-user') }} className='btn py-2 px-2 rounded-3'><HiOutlineEye size={20} className='primary-text' /> View Users</button> */}
                      <button onClick={() => { setShowModal(true); setActiveModalTab('delete-user'); setSelectedUser(item?.userId) }} className='btn py-2 px-2 text-danger rounded-3'><HiOutlineTrash size={20} className='danger-primary' /> Delete User</button>
                    </div>
                  </td>
                </tr>)}
              </tbody>
            </Table>

            <div className='text-end py-3'>
              <Pagination
                current={suspendedUser?.pageNumber ?? querySuspendedUser.Page}
                total={suspendedUser?.totalSize}
                pageSize={suspendedUser?.pageSize}
                onChange={onPageChangeSuspendedUser}
              />
            </div>
          </div>
        </>}
      </section>
      <ModalComponent size={undefined} showModal={showModal} hideModal={() => handleHideModal()}>
        <div className='p-4'>
          <div className='text-end'>
            <button className='btn p-0'><AiOutlineClose onClick={() => handleHideModal()} /></button>
          </div>
          {activeModalTab === 'view-user' || activeModalTab === 'add-user' ? <UserModalTabs activeModalTab={activeModalTab} modalUserData={modalUserData} rolesList={roles?.items} handleHideModal={handleHideModal} refetchUser={handleRefetchUsers} /> :
            <RoleModalTabs activeModalTab={activeModalTab} permissions={permissions} modalRoleData={modalRoleData} handleHideModal={handleHideModal} refetchRoles={handleRefetchRoles} />}

          {activeModalTab === 'suspend-user' && <div className='px-3'>
            <div className='my-3text-center '><img src={Suspend} width='120px' /></div>
            <p className='fs-5 fw-bold'>Confirm suspension of selected users?</p>
            <p className='text-secondary'>Are you certain you wish to proceed with the suspension of the selected users?</p>
            <div className='pt-3 pb-4'>
              <button disabled={loading} type='button' onClick={() => handleSuspendUser()} className='btn-yellow w-100 border-0 py-3 rounded-5'>Suspend users {loading && <Spinner size='sm' />}</button>
            </div>
          </div>}

          {activeModalTab === 'reactivate-user' && <div className='px-3'>
            <div className='my-3 text-center'><img src={info} width='120px' /></div>
            <p className='fs-5 fw-bold'>Confirm reactivation of selected user(s)</p>
            <p className='text-secondary'>Are you sure you want to reactivate the selected user(s)? <br />Activating this user(s) would mean they would have access to JobPro</p>
            <div className='pt-3 pb-4'>
              <button disabled={loading} type='button' onClick={() => handleReactivateUser()} className='btn-primary w-100 border-0 py-3 rounded-5'>Confirm {loading && <Spinner size='sm' />}</button>
            </div>
          </div>}

          {activeModalTab === 'delete-user' && <div className='px-3'>
            <div className='my-3 text-center'><img src={info} width='120px' /></div>
            <p className='fs-5 fw-bold'>Confirm deletion of selected user</p>
            <p className='text-secondary'>Are you sure you want to delete the selected user(s)? <br />Activating this user(s) would mean they would have access to JobPro</p>
            <div className='pt-3 pb-4'>
              <button disabled={loading} type='button' onClick={() => handleDeleteUser()} className='btn btn-danger w-100 border-0 py-3 rounded-5'>Confirm {loading && <Spinner size='sm' />}</button>
            </div>
          </div>}
        </div>
      </ModalComponent>
    </Layout>
  )
}

export default UserManagement;
